var map = {
	"./DSCF6738.jpg": 8840,
	"./DSCF6749.jpg": 574,
	"./DSCF6775.jpg": 6716,
	"./DSCF6779.jpg": 403,
	"./DSCF6792.jpg": 1988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;